import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { action, observable } from 'mobx'
import { ICONS } from '@Const/common'
import './index.scss'
import Button from '@Components/Buttons/Button'
import ArrowButton from '@Components/Buttons/Arrow'
import TagButton from '@Components/Buttons/TagButton'
import CheckBox from '@Components/Selectors/Checkbox'
import ToggleLabel from '@Components/Selectors/ToggleLabel'
import ToggleSelector from '@Components/Selectors/ToggleSelector'
import InputText from '@Components/Fields/InputText'
import InputSearch from '@Components/Fields/InputSearch'
import InputWithButton from '@Components/Fields/InputWithButton'
import Input from '@Components/Fields/Input'
import { FormProvider, useForm } from 'react-hook-form'
import InputForm from '@App/kit/fields/InputForm'
import InputTextForm from '@App/kit/fields/InputTextForm'
import Dropdown from '@Components/Selectors/Dropdown'
import { SelectOption } from '@Components/Selectors/Select'
import DropdownForm from '@App/kit/fields/DropdownForm'
import PhoneNumberComponent from '@Components/Fields/PhoneNumberComponent'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import { USER_FORM } from '@Const/forms-constants'
import { StoresContext } from '@App/contexts'
import CheckboxForm from '@App/kit/fields/CheckboxForm'
import { CheckboxSize } from '@App/enum/checkbox-size'
import { FormFieldTypes } from '@App/enum/form-field-types'
import MailingAddress from '@App/kit/fields/MailingAddress'
import MailingAddressToolTip from '@Components/Tooltips/MailingAddressToolTip'
import { getMailingAddressFormProps } from '@App/forms/common/mailing-address-form'
import PhoneNumberForm from '@Fields/PhoneNumberForm'
import { createPhoneNumberFormFields } from '@App/forms/common/phone-number-form'
import WizardRegisterWorkFlow from '@Components/WizardRegisterWorkFlow'
import { z } from 'zod'
import TablesForm from '@Components/ViewWork/Table/TablesForm'
import { TableRowData } from '@Components/ViewWork/Table'

interface FormInputs {
    field1: string
    field2: string
    field3: string
    field4: string
}

interface FormInputsSecondary {
    field1: string
    field2: string
    field3: string
    field4: string
}

interface FormInputs2 {
    field5: string
}

interface PhoneFormInput {
    phoneCountryCode: string
    phoneAreaCode: string
    phoneNumber: string
}

interface AddressFormInput {
    streetAddress: string
    unitNumber: string
    attention: string
    city: string
    state: string
    country: string
    postalCode: string
}

const UiComponentsScene = observer(() => {
    const { libStore } = useContext(StoresContext)

    const options: SelectOption[] = [
        {
            label: 'Option 1',
            value: 'option1',
            id: 'option1',
        },
        {
            label: 'Option 2',
            value: 'option2',
            id: 'option2',
        },
    ]

    const countries = libStore.countries
    const states = libStore.statesForCountry(840)

    // eslint-disable-next-line no-console
    const getCheckboxState = (checked: boolean) => console.log('checked: ' + checked)
    // eslint-disable-next-line no-console
    const getToggleState = (checked: boolean) => console.log(checked ? 'on' : 'off')
    // eslint-disable-next-line no-console
    const getToggleOption = (option: string) => console.log(option)

    const errorMessage = observable.box('')

    const getInputValue = action((value: string) => {
        errorMessage.set(value === 'error' ? 'Error message' : '')
    })

    // if you need to debug your validation schema

    // resolver: async (data, context, options) => {
    //     // you can debug your validation schema here
    //     console.log("formData", data)
    //     console.log(
    //             "validation result",
    //             await anyResolver(schema)(data, context, options)
    //     )
    //     return anyResolver(schema)(data, context, options)
    // }
    const methods = useForm<FormInputs>()
    const methodsSecondary = useForm<FormInputsSecondary>()

    useEffect(() => {
        methods.setError('field3', { message: 'Error Message' })
        methodsSecondary.setError('field3', { message: 'Error Message' })
    }, [methods, methodsSecondary])

    // eslint-disable-next-line no-console
    const onSubmit = (data: any) => console.log(data)

    const methods2 = useForm<FormInputs2>()

    const phoneNumberMethods = useForm<PhoneFormInput>()

    const addressMethods = useForm<AddressFormInput>()

    const [tableRows, setTableRows] = useState<TableRowData[]>([
        {
            removeCellIdentifier: '',
            removable: true,
            cells: ['TEST', 'TEST', 'TEST'],
            subTables: [
                {
                    headerRow: { row: [{ text: 'SUB_ROW_1' }, { text: 'SUB_ROW_2' }, { text: 'SUB_ROW_3' }] },
                    rows: [
                        {
                            removeCellIdentifier: '',
                            removable: true,
                            cells: ['SUB1', 'SUB2', 'SUB3'],
                        },
                        {
                            removeCellIdentifier: '',
                            removable: true,
                            cells: ['SUB1', 'SUB2', 'SUB3'],
                        },
                        {
                            removeCellIdentifier: '',
                            removable: true,
                            cells: ['SUB1', 'SUB2', 'SUB3'],
                        },
                    ],
                },
            ],
        },
        {
            removeCellIdentifier: '',
            removable: true,
            cells: ['TEST 2', 'TEST 2', 'TEST 2'],
        },
        {
            removeCellIdentifier: '',
            removable: true,
            cells: ['TEST 3', 'TEST 3', 'TEST 3'],
        },
    ])

    return (
        <div className="components-kit-wrapper">
            <section className="address-kit">
                {/* The following section is the old layout of the signup page*/}
                <section className="old-address-wrapper">
                    <div className="address-wrapper info-wrapper">
                        <h5>
                            Old MailingAddress Component
                            <CustomToolTip
                                type="i"
                                info={
                                    'Please enter your personal address. This information is used' +
                                    " to verify your identity. Once you are registered as a user, you'll be able to use your business" +
                                    ' information to create a Member and start managing your works.'
                                }
                            />
                        </h5>
                        <div className="inputs-area">
                            <InputText
                                mainColor
                                id={USER_FORM.streetAddress.id}
                                label={USER_FORM.streetAddress.label}
                                onChange={() => {}}
                            />
                            <InputText
                                mainColor
                                id={USER_FORM.unitNumber.id}
                                label={USER_FORM.unitNumber.label}
                                onChange={() => {}}
                            />
                            <InputText
                                mainColor
                                id={USER_FORM.city.id}
                                label={USER_FORM.city.label}
                                onChange={() => {}}
                            />
                            <Dropdown
                                options={countries}
                                id={USER_FORM.country.id}
                                label={USER_FORM.country.label}
                                mainColor
                                isNumberType
                                isSearchable
                                onChange={() => {}}
                            />
                            <Dropdown
                                options={states}
                                id={USER_FORM.state.id}
                                label={USER_FORM.state.label}
                                mainColor
                                isSearchable
                                onChange={() => {}}
                            />
                            <InputText
                                mainColor
                                id={USER_FORM.postalCode.id}
                                label={USER_FORM.postalCode.label}
                                onChange={() => {}}
                            />
                        </div>
                    </div>
                </section>
                <section>
                    <FormProvider {...addressMethods}>
                        <form onSubmit={addressMethods.handleSubmit(onSubmit)}>
                            <MailingAddress
                                title="New MailingAddress Component"
                                mailingAddressFormProps={getMailingAddressFormProps()}
                                toolTip={<MailingAddressToolTip />}
                            />
                        </form>
                    </FormProvider>
                </section>
            </section>
            <section className="phone-number-kit">
                <section className="old-phone-number-component">
                    <PhoneNumberComponent onChange={() => {}} />
                </section>
                <section>
                    <FormProvider {...phoneNumberMethods}>
                        <form onSubmit={phoneNumberMethods.handleSubmit(onSubmit)}>
                            <PhoneNumberForm phoneNumberFormProps={createPhoneNumberFormFields()} />
                        </form>
                    </FormProvider>
                </section>
            </section>
            <section className="selectors-kit">
                <section>
                    <Dropdown mainColor label="Old Select" options={options} />
                    <FormProvider {...methods2}>
                        <form onSubmit={methods2.handleSubmit(onSubmit)}>
                            <DropdownForm
                                name="field5"
                                mainColor
                                label="New Select"
                                options={options}
                                type={FormFieldTypes.DROPDOWN}
                            />
                        </form>
                    </FormProvider>
                </section>
                <section>
                    <Dropdown mainColor={false} label="Old Select" options={options} />
                    <FormProvider {...methods2}>
                        <form onSubmit={methods2.handleSubmit(onSubmit)}>
                            <DropdownForm
                                name="field5"
                                mainColor={false}
                                label="New Select"
                                options={options}
                                type={FormFieldTypes.DROPDOWN}
                            />
                        </form>
                    </FormProvider>
                </section>
            </section>
            <section className="typography-kit">
                <h1>H1</h1>
                <h2>H2</h2>
                <h3>H3</h3>
                <h4>H4</h4>
                <h5>H5</h5>
                <p>paragraph</p>
                <span>text</span>
                <span className="bold">bold text</span>
                <span className="blue-text">blue text</span>
                <span className="small">small text</span>
                <a href="/">link</a>
            </section>
            <section className="padding-kit">
                <div className="padding-12">
                    <div />
                </div>
                <div className="padding-24">
                    <div />
                </div>
                <div className="padding-48">
                    <div />
                </div>
                <div className="padding-96">
                    <div />
                </div>
            </section>
            <section className="icons-kit">
                <img src={ICONS.account} alt="Accounts" />
                <img src={ICONS.account_circle} alt="accountCircle" />
                <img src={ICONS.account_multi} alt="account_multi" />
                <img src={ICONS.add} alt="add" />
                <img src={ICONS.arrow_back} alt="arrowBack" />
                <img src={ICONS.arrow_forward} alt="arrowForward" />
                <img src={ICONS.catalog} alt="catalog" />
                <img src={ICONS.check} alt="check" />
                <img src={ICONS.chevron_drop_down} alt="chevronDropDown" />
                <img src={ICONS.chevron_drop_up} alt="chevronDropUp" />
                <img src={ICONS.chevron_left} alt="chevronLeft" />
                <img src={ICONS.chevron_right} alt="chevronRight" />
                <img src={ICONS.close} alt="close" />
                <img src={ICONS.done} alt="done" />
                <img src={ICONS.download} alt="download" />
                <img src={ICONS.error} alt="error" />
                <img src={ICONS.facebook} alt="facebook" />
                <img src={ICONS.help} alt="help" />
                <img src={ICONS.home} alt="home" />
                <img src={ICONS.instagram} alt="instagram" />
                <img src={ICONS.linkedin} alt="linkedin" />
                <img src={ICONS.menu} alt="menu" />
                <img src={ICONS.notifications} alt="notifications" />
                <img src={ICONS.pause_circle_filled} alt="pauseCircleFilled" />
                <img src={ICONS.play_circle_filled} alt="playCircleFilled" />
                <img src={ICONS.report} alt="report" />
                <img src={ICONS.search} alt="search" />
                <img src={ICONS.search_alt} alt="search" />
                <img src={ICONS.settings} alt="settings" />
                <img src={ICONS.summary} alt="summary" />
                <img src={ICONS.twitter} alt="twitter" />
                <img src={ICONS.upload} alt="upload" />
                <img src={ICONS.warning} alt="warning" />
            </section>
            <section className="selectors-kit">
                <section>
                    <FormProvider {...methods}>
                        <form onSubmit={methods.handleSubmit(onSubmit)}>
                            <CheckBox
                                id="test1"
                                onClick={getCheckboxState}
                                mainColor
                                size="normal"
                                text="Old Checkbox"
                            />
                            <CheckboxForm
                                name="field1"
                                type={FormFieldTypes.CHECKBOX}
                                size={CheckboxSize.normal}
                                label="New Checkbox"
                            />
                            <CheckBox
                                id="test2"
                                onClick={getCheckboxState}
                                mainColor
                                size="small"
                                text="Old Small Checkbox"
                            />
                            <CheckboxForm
                                name="field2"
                                type={FormFieldTypes.CHECKBOX}
                                size={CheckboxSize.small}
                                label="New Small Checkbox"
                            />

                            <ToggleLabel mainColor onClick={getToggleState} label="Label" />
                            <ToggleLabel mainColor onClick={getToggleState} label="Label" disabled />
                            <ToggleLabel mainColor onClick={getToggleState} label="Label" disabled checked />

                            <ToggleSelector mainColor onClick={getToggleOption} option1="Option 1" option2="Option 2" />
                            <ToggleSelector
                                mainColor
                                onClick={getToggleOption}
                                option1="Option 1"
                                option2="Option 2"
                                disabled
                            />
                            <ToggleSelector
                                mainColor
                                onClick={getToggleOption}
                                option1="Option 1"
                                option2="Option 2"
                                disabled
                                checkedSecondOption
                            />
                        </form>
                    </FormProvider>
                </section>
                <section>
                    <FormProvider {...methods}>
                        <form onSubmit={methods.handleSubmit(onSubmit)}>
                            <CheckBox
                                id="test3"
                                onClick={getCheckboxState}
                                mainColor={false}
                                size="normal"
                                text="Old Checkbox"
                                checked
                            />
                            <CheckboxForm
                                name="field1"
                                mainColor={false}
                                size={CheckboxSize.normal}
                                type={FormFieldTypes.CHECKBOX}
                                checked
                                label="New Checkbox"
                            />
                            <CheckBox
                                id="test4"
                                onClick={getCheckboxState}
                                mainColor={false}
                                size="small"
                                text="Old Small Checkbox"
                                checked
                            />
                            <CheckboxForm
                                name="field2"
                                mainColor={false}
                                checked
                                type={FormFieldTypes.CHECKBOX}
                                size={CheckboxSize.small}
                                label="New Small Checkbox"
                            />

                            <ToggleLabel mainColor={false} onClick={getToggleState} label="Label" />
                            <ToggleLabel mainColor={false} onClick={getToggleState} label="Label" disabled />
                            <ToggleLabel mainColor={false} onClick={getToggleState} label="Label" disabled checked />

                            <ToggleSelector
                                mainColor={false}
                                onClick={getToggleOption}
                                option1="Option 1"
                                option2="Option 2"
                            />
                            <ToggleSelector
                                mainColor={false}
                                onClick={getToggleOption}
                                option1="Option 1"
                                option2="Option2"
                                disabled
                            />
                            <ToggleSelector
                                mainColor={false}
                                onClick={getToggleOption}
                                option1="Option 1"
                                option2="Option2"
                                disabled
                                checkedSecondOption
                            />
                        </form>
                    </FormProvider>
                </section>
            </section>
            <section className="buttons-kit">
                <section>
                    <Button mainColor type="primary">
                        Primary
                    </Button>
                    <Button mainColor type="primary-small">
                        Small
                    </Button>
                    <Button mainColor type="secondary">
                        Secondary
                    </Button>
                    <Button mainColor type="tertiary">
                        Tertiary
                    </Button>

                    <Button mainColor type="primary" disabled>
                        Primary
                    </Button>
                    <Button mainColor type="primary-small" disabled>
                        Small
                    </Button>
                    <Button mainColor type="secondary" disabled>
                        Secondary
                    </Button>
                    <Button mainColor type="tertiary" disabled>
                        Tertiary
                    </Button>

                    <ArrowButton mainColor type="left" />
                    <ArrowButton mainColor type="right" />
                    <ArrowButton mainColor type="up" />
                    <ArrowButton mainColor type="down" />

                    <ArrowButton mainColor type="left" disabled />
                    <ArrowButton mainColor type="right" disabled />
                    <ArrowButton mainColor type="up" disabled />
                    <ArrowButton mainColor type="down" disabled />

                    <TagButton mainColor>Perspective Tag</TagButton>
                </section>
                <section>
                    <Button mainColor={false} type="primary">
                        Primary
                    </Button>
                    <Button mainColor={false} type="primary-small">
                        Small
                    </Button>
                    <Button mainColor={false} type="secondary">
                        Secondary
                    </Button>
                    <Button mainColor={false} type="tertiary">
                        Tertiary
                    </Button>

                    <Button mainColor={false} type="primary" disabled>
                        Primary
                    </Button>
                    <Button mainColor={false} type="primary-small" disabled>
                        Small
                    </Button>
                    <Button mainColor={false} type="secondary" disabled>
                        Secondary
                    </Button>
                    <Button mainColor={false} type="tertiary" disabled>
                        Tertiary
                    </Button>

                    <ArrowButton mainColor={false} type="left" />
                    <ArrowButton mainColor={false} type="right" />
                    <ArrowButton mainColor={false} type="up" />
                    <ArrowButton mainColor={false} type="down" />

                    <ArrowButton mainColor={false} type="left" disabled />
                    <ArrowButton mainColor={false} type="right" disabled />
                    <ArrowButton mainColor={false} type="up" disabled />
                    <ArrowButton mainColor={false} type="down" disabled />

                    <TagButton mainColor={false}>Perspective Tag</TagButton>
                </section>
            </section>
            <section className="fields-kit">
                <section>
                    <FormProvider {...methods}>
                        <form onSubmit={methods.handleSubmit(onSubmit)}>
                            <Input title="Old Input" mainColor id="b1" type="submit" onChange={() => {}} />
                            <InputForm
                                name="field1"
                                label="New Input"
                                mainColor
                                placeholder="New Input"
                                type={FormFieldTypes.TEXT}
                            />
                            <InputText
                                mainColor
                                id="1"
                                label="Old InputText"
                                assistiveText="Assistive text"
                                onChange={getInputValue}
                                errorMessage={errorMessage.get()}
                            />
                            <InputTextForm
                                name="field2"
                                label="New InputText"
                                assistiveText="Assistive text"
                                type={FormFieldTypes.TEXT}
                            />
                            <InputText
                                mainColor
                                id="2"
                                label="Old Error Message InputText"
                                assistiveText="Assistive text"
                                onChange={() => {}}
                                errorMessage="Error message"
                            />
                            <InputTextForm
                                name="field3"
                                label="New Error Message InputText"
                                type={FormFieldTypes.TEXT}
                            />
                            <InputText
                                mainColor
                                id="3"
                                label="Old Disabled InputText"
                                assistiveText="Assistive text"
                                onChange={() => {}}
                                disabled
                            />
                            <InputTextForm
                                name="field4"
                                type={FormFieldTypes.TEXT}
                                label="New Disabled InputText"
                                assistiveText="Assistive text"
                                registerOptions={{
                                    disabled: true,
                                }}
                            />

                            <InputSearch mainColor id="s1" onChange={() => {}} />

                            <InputWithButton mainColor id="b1" type="submit" onChange={() => {}} />
                            <InputWithButton mainColor id="b2" type="sign-up" onChange={() => {}} />
                            <InputWithButton mainColor id="b3" type="submit" onChange={() => {}} errorMessage="Error" />
                            <InputWithButton
                                mainColor
                                id="b4"
                                type="sign-up"
                                onChange={() => {}}
                                errorMessage="Error"
                            />
                        </form>
                    </FormProvider>
                </section>
                <section>
                    <FormProvider {...methodsSecondary}>
                        <form onSubmit={methodsSecondary.handleSubmit(onSubmit)}>
                            <Input title="Old Input" mainColor={false} id="b1" type="submit" onChange={() => {}} />
                            <InputForm
                                name="field1"
                                label="New Input"
                                type={FormFieldTypes.TEXT}
                                mainColor={false}
                                placeholder="New Input"
                            />
                            <InputText
                                mainColor={false}
                                id="4"
                                label="Old InputText"
                                assistiveText="Assistive text"
                                onChange={() => {}}
                            />
                            <InputTextForm
                                name="field2"
                                label="New InputText"
                                type={FormFieldTypes.TEXT}
                                assistiveText="Assistive text"
                                mainColor={false}
                            />
                            <InputText
                                mainColor={false}
                                id="5"
                                label="Old Error Message InputText"
                                assistiveText="Assistive text"
                                onChange={() => {}}
                                errorMessage="Error message"
                            />
                            <InputTextForm
                                name="field3"
                                label="New Error Message InputText"
                                type={FormFieldTypes.TEXT}
                                mainColor={false}
                            />
                            <InputText
                                mainColor={false}
                                id="6"
                                label="Old Disabled InputText"
                                assistiveText="Assistive text"
                                onChange={() => {}}
                                disabled
                            />
                            <InputTextForm
                                name="field4"
                                label="New Disabled InputText"
                                assistiveText="Assistive text"
                                mainColor={false}
                                type={FormFieldTypes.TEXT}
                                registerOptions={{
                                    disabled: true,
                                }}
                            />

                            <InputSearch mainColor={false} id="s1" onChange={() => {}} />

                            <InputWithButton mainColor={false} id="b5" type="submit" onChange={() => {}} />
                            <InputWithButton mainColor={false} id="b6" type="sign-up" onChange={() => {}} />
                            <InputWithButton
                                mainColor={false}
                                id="b7"
                                type="submit"
                                onChange={() => {}}
                                errorMessage="Error"
                            />
                            <InputWithButton
                                mainColor={false}
                                id="b8"
                                type="sign-up"
                                onChange={() => {}}
                                errorMessage="Error"
                            />
                        </form>
                    </FormProvider>
                </section>
            </section>

            <section className="register-wizard-flow-kit">
                <WizardRegisterWorkFlow />
            </section>

            <section className="registration-table-section">
                <TablesForm
                    headingDecoration={{
                        icon: 'recordingWriters',
                        title: 'TABLE HEADER',
                        required: true,
                    }}
                    tableInfos={[
                        {
                            headerRow: {
                                row: [{ text: 'Name' }, { text: 'IPI' }, { text: 'Role' }],
                                removableCells: true,
                            },
                            rows: tableRows,
                        },
                    ]}
                    footerRow={[
                        <Button key="optional-footer-button" mainColor type="primary">
                            OPTIONAL FOOTER BUTTON
                        </Button>,
                    ]}
                    addButtonTitle="Add Row"
                    onAddButtonClicked={() => {
                        const newRows = [...tableRows]
                        newRows.push({
                            removeCellIdentifier: '',
                            removable: true,
                            cells: ['TEST', 'TEST', 'TEST'],
                        })
                        setTableRows(newRows)
                    }}
                    onRemoveCellClicked={(index) => {
                        const newRows = [...tableRows]
                        newRows.splice(index, 1)
                        setTableRows(newRows)
                    }}
                    validationSchema={z
                        .object({
                            example: z.string().optional(),
                        })
                        .array()}
                />
            </section>
        </div>
    )
})

export default UiComponentsScene
